import React from 'react';
import styled from 'styled-components';
import { Planet } from 'react-planet';
import Project from '../Projects/Project';

const PlanetContainer = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    min-width: 100px;
    min-height: 500px;
`;

const TitleCardStyled = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
`;

const TitleCardInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: transparent;
`;

const TitleCardPhoto = styled.img`
    width: 20vmin;
    height: 20vmin;
    border-radius: 50%;
    min-width: 100px;
    min-height: 100px;
    transition: 0.3s;
    &:hover {
        border-radius: 10px;
        object-fit: default;
        transform: scale(1.05);
    }
`;

// name should be placed relative to title card photo, under it
const Name = styled.h1`
    font-size: 1.2em;
    font-weight: bold;
    text-align: center;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.5s linear;
    ${TitleCardInfo}:hover & {
        visibility: visible;
        opacity: 1;
    }
    position: absolute;
    top: 61%;
`;


class TitleCard extends React.Component {

    constructor(props) {
        super(props);
        this.orbitTracker = window;
        this.state = {
            projects: [],
            orbitRadius: 400,
        };
    }
    
    updateOrbit = () => {
        let val = Math.min(this.orbitTracker.innerWidth, this.orbitTracker.innerHeight);
        this.setState({orbitRadius: val / 3});
    };

    render() {
        return (
            <PlanetContainer onresize={(e) => {
                console.log(e);
                
            }}>
                <Planet
                    centerContent={
                        <TitleCardStyled>
                            <TitleCardInfo>
                                <TitleCardPhoto src={this.props.photo}/>
                                <Name>{this.props.name}</Name>
                            </TitleCardInfo>
                        </TitleCardStyled>
                    }
                    orbitRadius={this.state.orbitRadius}
                    open
                    planetSize={100}
                >
                    {this.state.projects}
                </Planet>
            </PlanetContainer>
        );
    }

    componentDidMount() {
        this.orbitTracker.addEventListener('resize', this.updateOrbit);
    }

    componentWillUnmount() {
        this.orbitTracker.removeEventListener('resize', this.updateOrbit);
    }

    componentWillMount() {
        const dataDir = process.env.PUBLIC_URL + '/projects_data';
        const jsonPath = dataDir + '/projects.json';
        const imgsDir = dataDir + '/imgs';
        const projects = [];
        fetch(jsonPath)
        .then(response => response.json())
        .then(data => {
            data.forEach(project => {
                projects.push(<Project name={project.name} description={project.description} photo={imgsDir + '/' + project.photo} link={project.link} />);
            });
        }).then(() => {
            this.setState({projects: projects});
        });
        this.setState({orbitRadius: Math.min(this.orbitTracker.innerWidth, this.orbitTracker.innerHeight) / 3});
    }
}
    
export default TitleCard;
